import { UserModel } from "./UserModel";
import { CommentFileModel } from "./CommentFileModel";

/**Модель описывает комментарий */
export class CommentChatMessageModel {
  /**Идентификатор комментария */
  Id!: number;
  /**Комментарий на который отвечаем */
  ReplyComment?: CommentChatMessageModel;
  /**Сообщение */
  Message: string = "";
  /**Дата и время создания комментария */
  DateCreate!: Date;
  /**Автор комментария */
  Author!: UserModel;
  /**Прикрепленный файл */
  File?: CommentFileModel;
  /**ID папки куда грузим файлы */
  FileFolderId!: string;

  constructor(obj?: Partial<CommentChatMessageModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
